import * as types from './types';
import { RESET_DATASET } from 'store/dataset/types';
import { RESET_GRAPHICAL_STATISTICS } from '../types';

const initialState = {
  binWidth: 0,
  minBinWidth: 0,
  startPoint: 0,
  minStartPoint: 0,
  activeChartsAndGraphsTab: 0
};

export default (state = initialState, { type, binWidth, activeTab, minBinWidth, startPoint, minStartPoint }) => {
  switch (type) {
    case types.SET_ACTIVE_CHARTS_AND_GRAPHS_TAB:
      return { ...state, activeChartsAndGraphsTab: activeTab };
    case types.SET_BIN_WIDTH:
      return { ...state, binWidth };
    case types.SET_MIN_BIN_WIDTH:
      return { ...state, minBinWidth };
    case types.SET_STARTING_POINT:
      return { ...state, startPoint };
    case types.SET_MIN_STARTING_POINT:
      return { ...state, minStartPoint };
    case RESET_DATASET:
    case RESET_GRAPHICAL_STATISTICS:
      return initialState;
    default:
      return state;
  }
};
